import LoadingEffect from './LoadingEffect';
import '../../css/loadingStyle.scss';

export default LoadingEffect;
